import { render, staticRenderFns } from "./AssignmentOffers.vue?vue&type=template&id=6b85738a&"
import script from "./assignmentOffers?vue&type=script&lang=js&"
export * from "./assignmentOffers?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports